import { render, staticRenderFns } from "./CalloutBubble.vue?vue&type=template&id=6882e11c&"
import script from "./CalloutBubble.vue?vue&type=script&lang=js&"
export * from "./CalloutBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports